import React from "react";
import { Form, Segment } from "semantic-ui-react";
import CountriesDropDown from "../../components/shared/CountriesDropDown";
import { DatePicker } from "../../components/shared/DatePicker";
import TextInput from "../../components/shared/TextInput";
import { useTextResources } from "../../language";
import PropTypes from "prop-types";
import moment from "moment";

export default function GuestCard({ reservation, changeGuestDetails, changeLocationDetails }) {
  const text = useTextResources();
  return (
    <Segment
      style={{
        width: "100%",
        flex: 1,
      }}
      key="step1"
      className="lang-rtl"
    >
      <Form>
        <Form.Group widths="equal">
          <Form.Field
            fluid
            variant="outlined"
            label={text("FirstName")}
            required
            value={reservation?.Guest?.FirstName}
            onChange={(newValue) => changeGuestDetails(newValue, "FirstName")}
            control={TextInput}
          />
          <Form.Field
            fluid
            variant="outlined"
            label={text("LastName")}
            required
            value={reservation?.Guest?.LastName}
            onChange={(newValue) => changeGuestDetails(newValue, "LastName")}
            control={TextInput}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field
            fluid
            variant="outlined"
            label={text("Email")}
            required
            value={reservation?.Guest?.Email}
            onChange={(newValue) => changeGuestDetails(newValue, "Email")}
            control={TextInput}
          />
          <Form.Field
            control={TextInput}
            variant="outlined"
            label={text("Address")}
            value={reservation?.Guest?.Location?.StreetAndHomeNumber}
            onChange={(newValue) => changeLocationDetails(newValue, "StreetAndHomeNumber")}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field
            control={TextInput}
            variant="outlined"
            label={text("City")}
            value={reservation?.Guest?.Location?.City}
            onChange={(newValue) => changeLocationDetails(newValue, "City")}
          />
          <Form.Field
            control={TextInput}
            variant="outlined"
            label={text("ZipCode")}
            value={reservation?.Guest?.Location?.Zip}
            onChange={(newValue) => changeLocationDetails(newValue, "Zip")}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field
            control={CountriesDropDown}
            value={reservation?.Guest?.Location?.CountryId}
            varinat="outlined"
            label={text("Country")}
            clearable
            onChangeItem={({ Id }) => changeLocationDetails(Id, "CountryId")}
          />
          <Form.Field
            label={text("Birthday")}
            className="date-picker"
            value={moment(reservation?.Guest?.BirthDate || new Date()).toDate()}
            control={DatePicker}
            onChange={(newValue) => {
              changeGuestDetails(newValue, "BirthDate");
            }}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field
            control={TextInput}
            value={reservation?.Guest?.Phone}
            variant="outlined"
            required
            label={text("Phone")}
            onChange={(newValue) => changeGuestDetails(newValue, "Phone")}
          />
          <Form.Field
            control={TextInput}
            value={reservation?.Guest?.PassportNumber}
            variant="outlined"
            label={text("Passport")}
            required
            onChange={(newValue) => changeGuestDetails(newValue, "PassportNumber")}
          />
        </Form.Group>
      </Form>
    </Segment>
  );
}

GuestCard.propTypes = {
    reservation: PropTypes.object,
    changeGuestDetails: PropTypes.func,
    changeLocationDetails: PropTypes.func
};
